import script from "./Reset.vue?vue&type=script&setup=true&lang=ts"
export * from "./Reset.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__